import api from "../helpers/util";

export const fetchOffalsByDate = async (species, date) => {
  try {
    const response = await api.get(
      "/scheduling/offals/" + species + "/date/" + date
    );
    return response?.data?.result ?? "No  offals found.";
  } catch (error) {
    console.log("fetching Beef Offals err", error);
    throw new Error("Error fetching offals :", error);
  }
};
export const fetchOffalTypes = async (species) => {
  try {
    const response = await api.get("/scheduling/offals/" + species + "/types");
    return response?.data?.result ?? "No offal type found.";
  } catch (error) {
    console.log("fetching offal types err", error);
    throw new Error("Error fetching offal types :", error);
  }
};
export const createOffal = async (species, offalData) => {
  try {
    console.log("api", offalData);
    const response = await api.post(
      "/scheduling/offals/" + species + "/createOffal",
      offalData
    );
    // const data = await response.json();
    console.log("created offal", response.data);
    return response.data;
  } catch (error) {
    throw new Error("Error creating offal:", error);
  }
};
